import React, { useState } from 'react';
import './BadRecordingsTable.css';

const BadRecordingsTable = ({ badRecordings }) => {
  const [searchTerm, setSearchTerm] = useState('');

  // Check if badRecordings is defined before processing
  if (!badRecordings) {
    return <div>Loading...</div>; // or any other loading indicator
  }

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredData = badRecordings.reduce((accumulator, { date, TourId, SessionTableActual, segmentsStarted, segmentsUploaded }) => {
    const searchTermLower = searchTerm.toLowerCase();
    const dataString = `${date}-${TourId}-${SessionTableActual}`.toLowerCase();

    if (dataString.includes(searchTermLower)) {
      accumulator.push({
        date,
        TourId,
        SessionTableActual,
        segmentsStarted,
        segmentsUploaded,
      });
    }

    return accumulator;
  }, []);

  return (
    <div className="bad-recordings-container">
      <h2 className='title'>Recordings</h2>
      <div className="search-container">
        <input
          type="text"
          id="search"
          placeholder="Filter by Date, TourID, or Session Table..."
          value={searchTerm}
          onChange={handleSearchChange}
        />
      </div>
      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>TourId</th>
            <th>Session Table</th>
            <th>Segments Started</th>
            <th>Segments Uploaded</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map(({ date, TourId, SessionTableActual, segmentsStarted, segmentsUploaded }, index) => (
            <tr key={`${date}-${TourId}-${SessionTableActual}-${index}`}>
              <td>{date}</td>
              <td>{TourId}</td>
              <td>{SessionTableActual}</td>
              <td>{segmentsStarted}</td>
              <td>{segmentsUploaded}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BadRecordingsTable;
